import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setFlightTripSearchParam } from '../../../../../store/slices/tripSearch';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { flightSearch, updateFlightSearchObj } from '../../../../../store/slices/flight';

const LoadMoreFlightsButton = ({
  tripId, className,
}) => {
  const dispatch = useDispatch();
  const isTripSearch = !tripId;
  const {
    totalFlights, foundTotalFlights, hasUserInteractedWithFlightList,
  } = useSelector(flightSearchInput(tripId, isTripSearch));

  const handleLoadMoreFlights = () => {
    const payload = {
      tripId,
      isTripSearch,
      hasUserInteractedWithFlightList: false,
      foundTotalFlights: null,
    };
    if (isTripSearch) dispatch(setFlightTripSearchParam(payload));
    else dispatch(updateFlightSearchObj(payload));

    if (tripId) {
      dispatch(flightSearch({
        tripId,
        doShowProgressbar: true,
        doIgnoreStoredResults: true,
        foundTotalFlights: null,
      }));
    } else {
      dispatch(flightSearch({
        isTripSearch,
        doShowProgressbar: true,
        doIgnoreStoredResults: true,
        foundTotalFlights: null,
      }));
    }
  };

  return hasUserInteractedWithFlightList && totalFlights > 0
    && foundTotalFlights > 0 && totalFlights !== foundTotalFlights ? (
      <button className={clsx('banner w-full rounded bg-progressbar text-progressbar p-2 sticky top-0 z-10 mb-2', className)} type="button" onClick={handleLoadMoreFlights}>
        {' '}
        Load More (Found
        {' '}
        {foundTotalFlights}
        {' '}
        Flights)
      </button>
    ) : <></>;
};

LoadMoreFlightsButton.propTypes = {
  tripId: PropTypes.string,
  className: PropTypes.string,
};

LoadMoreFlightsButton.defaultProps = {
  tripId: undefined,
  className: undefined,
};

export default LoadMoreFlightsButton;
